// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import {Dictionary} from '../../../shared/models/dictionary.model';
import {IBaseType} from '../../../shared/enums/ibase-type.enum';

export interface IFinanceDisbursementRequestStatusType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class FinanceDisbursementRequestStatusType implements IFinanceDisbursementRequestStatusType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
        Returns Pending FinanceDisbursementRequestStatusType
	**/
    get Pending(): IFinanceDisbursementRequestStatusType {
        return this.FromId(1);
    }
    /**
        Returns Approved FinanceDisbursementRequestStatusType
	**/
    get Approved(): IFinanceDisbursementRequestStatusType {
        return this.FromId(2);
    }
    /**
        Returns Denied FinanceDisbursementRequestStatusType
	**/
    get Denied(): IFinanceDisbursementRequestStatusType {
        return this.FromId(3);
    }
    /**
        Returns Issued FinanceDisbursementRequestStatusType
    **/
    get Issued(): IFinanceDisbursementRequestStatusType {
        return this.FromId(4);
    }
    /**
        Returns Digital FinanceDisbursementRequestStatusType
    **/
    get Digital(): IFinanceDisbursementRequestStatusType {
        return this.FromId(5);
    }
    /**
        Returns Preparing FinanceDisbursementRequestStatusType
    **/
    get Preparing(): IFinanceDisbursementRequestStatusType {
        return this.FromId(6);
    }
    /**
        Returns Assigned FinanceDisbursementRequestStatusType
    **/
    get Assigned(): IFinanceDisbursementRequestStatusType {
        return this.FromId(7);
    }
    /**
        Returns Processed FinanceDisbursementRequestStatusType
    **/
    get Processed(): IFinanceDisbursementRequestStatusType {
        return this.FromId(8);
    }
    /**
        Returns SenttoAFIS FinanceDisbursementRequestStatusType
    **/
    get SentToAFIS(): IFinanceDisbursementRequestStatusType {
        return this.FromId(9);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: '1', displayValue: 'Pending', description: 'Disbursement is pending.', sortOrder: 1, active: true });
        this._dictionary.add('2', { id: 2, value: '2', displayValue: 'Approved', description: 'Disbursement is approved.', sortOrder: 2, active: true });
        this._dictionary.add('3', { id: 3, value: '3', displayValue: 'Denied', description: 'Disbursement is denied.', sortOrder: 3, active: true });
        this._dictionary.add('4', { id: 4, value: '4', displayValue: 'Issued', description: 'Disbursement has been issued.', sortOrder: 4, active: true });
        this._dictionary.add('5', { id: 5, value: '5', displayValue: 'Digital', description: 'Digital disbursement has been issued.', sortOrder: 5, active: true });
        this._dictionary.add('6', { id: 6, value: '6', displayValue: 'Preparing', description: 'Disbursement is being prepared.', sortOrder: 6, active: true });
        this._dictionary.add('7', { id: 7, value: '7', displayValue: 'Assigned', description: 'Disbursement has been assigned.', sortOrder: 7, active: true });
        this._dictionary.add('8', { id: 8, value: '8', displayValue: 'Processed', description: 'Disbursement has been processed.', sortOrder: 8, active: true });
        this._dictionary.add('9', { id: 9, value: '9', displayValue: 'SentToAFIS', description: 'Sent To AFIS', sortOrder: 9, active: true });

    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IFinanceDisbursementRequestStatusType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IFinanceDisbursementRequestStatusType {
        var match = this._dictionary.getValues().filter(function(data) {
            return data.value == value;
        });

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IFinanceDisbursementRequestStatusType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IFinanceDisbursementRequestStatusType[] {
        return this.GetAll().filter(function(data) {
            return data.active;
        });
    }

    public Sort(primaryField, secondaryField, reverse): IFinanceDisbursementRequestStatusType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = function(path, reverse, primer, then) {
        var get = function(obj, path) {
                if (path) {
                    path = path.split('.');
                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }
                    return obj[path[len]];
                }
                return obj;
            },
            prime = function(obj) {
                return primer ? primer(get(obj, path)) : get(obj, path);
            };

        return function(a, b) {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
